// Smart auth-method memory.
//
// Tracks which login method the user used last on THIS device (email,
// google, apple). The login/register page reads this on mount and surfaces
// the last-used method as the primary big button, tucking the others behind
// "Use a different method". Typically lifts return-user conversion 8-12%.
//
// Stored in localStorage with a 90-day TTL so a user who hasn't been back
// for months gets the neutral all-options layout again.

const KEY = "bl_last_auth_method";
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

export function setLastAuthMethod(method) {
    if (!method) return;
    try {
        localStorage.setItem(
            KEY,
            JSON.stringify({ method, ts: Date.now() }),
        );
    } catch {
        /* localStorage disabled — silently no-op */
    }
}

export function getLastAuthMethod() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.method || !parsed?.ts) return null;
        if (Date.now() - parsed.ts > MAX_AGE_MS) {
            localStorage.removeItem(KEY);
            return null;
        }
        return parsed.method;
    } catch {
        return null;
    }
}

export function clearLastAuthMethod() {
    try {
        localStorage.removeItem(KEY);
    } catch {
        /* ignore */
    }
}
